import React from 'react';
import ReactAutocomplete from 'react-autocomplete';
import styles from './styles.modules.scss';
import Search from '../../ModelTemplateHeader/btn-search.svg';
import Close from '../close.svg';
import enhance from './enhance.js';

const DesignOptionFilterForm = ({
  filterOption,
  menuOpen,
  placeHolder = 'Search',
  search,
  searchMenuVisibility,
  setOption,
  openDropdown,
  filteredOptions,
  selectedOptions,
  removeOption,
  menuStyles,
}) => {
  return (
    <div className={styles.designOptionForm}>
      <div className={styles.inputContainer}>
        <ReactAutocomplete
          getItemValue={item => item.description}
          items={filteredOptions}
          renderItem={item => {
            return (
              <div
                className={styles.menuOption}
                data-test={`menuItem-${item.id}`}
              >
                {item.id} {item.description}
              </div>
            );
          }}
          onMenuVisibilityChange={searchMenuVisibility}
          open={menuOpen}
          value={search}
          onChange={filterOption}
          onSelect={setOption}
          inputProps={{
            placeholder: placeHolder,
            onClick: openDropdown,
          }}
          menuStyle={menuStyles}
          wrapperProps={{
            className: styles.wrapper,
            'data-test': 'inputWrapper',
          }}
        />
        <img className={styles.searchIcon} src={Search} alt="search" />
      </div>
      <div className={styles.selectedOptionsContainer}>
        {selectedOptions &&
          selectedOptions.map(option => (
            <span
              key={option.id}
              className={styles.selectedOption}
              data-test="selectedOption"
            >
              <img
                src={Close}
                alt="remove"
                className={styles.remove}
                onClick={() => removeOption(option)}
                data-test="removeOption"
              />{' '}
              {option.id} {option.description}
            </span>
          ))}
      </div>
    </div>
  );
};

export default enhance(DesignOptionFilterForm);
